/**
 * Global Date Formatting Utility - Format dd.mm.yyyy
 * Used across the entire e-Tesa application for consistent Romanian date display
 */

/**
 * Formats any date string or Date object to dd.mm.yyyy format
 * Handles: ISO strings, Date objects, yyyy-mm-dd, dd/mm/yyyy, dd.mm.yyyy
 * Returns original string if parsing fails
 */
export const formatDateRO = (dateInput) => {
  if (!dateInput) return '';
  
  // Already in dd.mm.yyyy format
  if (typeof dateInput === 'string' && /^\d{2}\.\d{2}\.\d{4}$/.test(dateInput)) {
    return dateInput;
  }
  
  let date;
  
  if (dateInput instanceof Date) {
    date = dateInput;
  } else if (typeof dateInput === 'string') {
    // yyyy-mm-dd or ISO string
    if (/^\d{4}-\d{2}-\d{2}/.test(dateInput)) {
      date = new Date(dateInput);
    }
    // dd/mm/yyyy
    else if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateInput)) {
      const parts = dateInput.split('/');
      date = new Date(parts[2], parts[1] - 1, parts[0]);
    }
    // dd.mm.yyyy (with flexible digit count)
    else if (/^\d{1,2}\.\d{1,2}\.\d{4}$/.test(dateInput)) {
      const parts = dateInput.split('.');
      date = new Date(parts[2], parts[1] - 1, parts[0]);
    }
    else {
      date = new Date(dateInput);
    }
  } else {
    return String(dateInput);
  }
  
  if (isNaN(date.getTime())) return String(dateInput);
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  
  return `${day}.${month}.${year}`;
};

/**
 * Formats date + time to dd.mm.yyyy HH:mm format (Europe/Bucharest timezone)
 */
export const formatDateTimeRO = (dateInput) => {
  if (!dateInput) return '';
  
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return String(dateInput);
  
  return date.toLocaleString('ro-RO', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Bucharest'
  });
};

/**
 * Formats date for display in long form: "21 martie 2026"
 */
export const formatDateLongRO = (dateInput) => {
  if (!dateInput) return '';
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return String(dateInput);
  return date.toLocaleDateString('ro-RO', { day: 'numeric', month: 'long', year: 'numeric' });
};
